import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineHappeningApi } from '@/features/api/hooks/grapevine-happening/useGrapevineHappeningApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetHappeningParticipants = (postId = '') => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineHappeningApi();

  const requestParameters = { happeningId: postId };

  return useQuery({
    queryKey: [API_CACHE_KEYS.HAPPENING_PARTICIPANTS, requestParameters],
    queryFn: () =>
      api.getAllParticipantsById({
        ...requestParameters
      }),
    enabled: isAuthenticated && !isEmptyOrNull(requestParameters.happeningId)
  });
};
